import { MatDialogConfig } from '@angular/material/dialog';
import { DialogEditTarifaData } from './dialog-edit-tarifa.component';

/** Comparte reset de padding/panel con create-order (styles.css). */
export const EDIT_SERVICE_AMOUNT_PANEL_CLASS = 'create-order-panel';

export function buildEditServiceAmountDialogConfig(
  data: DialogEditTarifaData,
  options?: { disableClose?: boolean }
): MatDialogConfig<DialogEditTarifaData> {
  return {
    width: '460px',
    maxWidth: '94vw',
    panelClass: EDIT_SERVICE_AMOUNT_PANEL_CLASS,
    autoFocus: false,
    disableClose: options?.disableClose ?? false,
    data
  };
}
